// Define Global Spinner Modal
export var spinnerModalActive = false
export var readySpinnerModalActive = false
export var momoSpinnerModalActive = false
export var spinnerModal = null
export var readySpinnerModal = null
export var momoSpinnerModal = null

// Maintain Modal Count and Active Modals
var modalActive = false
var activeModalArray = []
var activeModalCount = 0;

export function coordinateModalShowBody() {
    console.log("active modals before modal up", activeModalCount)
    setModalShowBody()
    activeModalCount += 1;
    modalActive = true;
    activeModalArray.push(modalActive)
    console.log("active modals after modal up", activeModalCount)
}
  
export function coordinateModalShowBodyReset() {  
    document.documentElement.classList.remove('clipped')
    activeModalCount -= 1
    activeModalArray.pop()
    console.log("active modals before modal close", activeModalCount)
    console.log("active modal array before modal close", activeModalArray)
    if (activeModalArray.length < 1) {
      resetModalShowBody()
      activeModalCount = 0
      modalActive = false
    }
    console.log("active modals after modal close", activeModalCount)
    // Handle a situation where there is a mistrack of active modals
    setTimeout(function(){
      console.log("is modal active: ",modalActive)
      console.log("active modal array: ",activeModalArray)
      if (activeModalArray.length < 1) {
        activeModalCount = 0
        modalActive = false
        resetModalShowBody()
        document.documentElement.classList.remove('clipped')
      }
    }, 1000)
}


export function effectModalShowBodyReset() {  
    document.documentElement.classList.remove('clipped')
    activeModalCount -= 1
    activeModalArray = []
    console.log("active modals before modal close", activeModalCount)
    console.log("active modal array before modal close", activeModalArray)

    resetModalShowBody()
    activeModalCount = 0
    modalActive = false

    console.log("active modals after modal close", activeModalCount)    
}
  
// Very important for preventing document.body from scrolling
export function setModalShowBody() {
    var body = document.body;
    body.classList.add("modal-no-scroll-body");
}
// Very important for Re-Enabling document.body scrolling
export function resetModalShowBody() {
    var body = document.body;
    body.classList.remove("modal-no-scroll-body");
}


export function initializeModalControls() {
    //Add Event Listeners
    spinnerModal = document.getElementById("spinner-modal")
    readySpinnerModal = document.getElementById("ready-spinner-modal")
    momoSpinnerModal = document.getElementById("momo-spinner-modal")

    /* Modal: open */

    Array.from(document.getElementsByClassName('--pb-modal')).forEach(el => {
      el.addEventListener('click', e => {
        displayTargetModal(e)
      })
    });

    /* Modal: close */

    Array.from(document.getElementsByClassName('--pb-modal-close')).forEach(el => {
      el.addEventListener('click', e => {
        closeTargetParentModal(e)
      })
    })

    /* Notification dismiss */

    Array.from(document.getElementsByClassName('--pb-notification-dismiss')).forEach(el => {
      el.addEventListener('click', e => {
        e.currentTarget.closest('.notification').classList.add('hidden')
        coordinateModalShowBodyReset()
      })
    })
}

export function closeTargetParentModal(e) {
  e.currentTarget.closest('.modal').classList.remove('active')
  document.documentElement.classList.remove('clipped')
  coordinateModalShowBodyReset()
}

export function displayTargetModal(e) {
  const modalTarget = e.currentTarget.getAttribute('data-target')

  document.getElementById(modalTarget).classList.add('active')
  document.documentElement.classList.add('clipped')
  coordinateModalShowBody()
}


export function activateSpinnerModal() {
    if (spinnerModal !== null) {
        spinnerModal.classList.remove('hidden')
        spinnerModal.classList.add('active')
        // Add no scroll class to body?
        spinnerModalActive = true
    }
}

export function activateReadySpinnerModal() {
    if (readySpinnerModal !== null) {
        readySpinnerModal.classList.remove('hidden')
        readySpinnerModal.classList.add('active')
        // Add no scroll class to body?
        readySpinnerModalActive = true
    }
}

export function activateMoMoSpinnerModal() {
    if (momoSpinnerModal !== null) {
        momoSpinnerModal.classList.remove('hidden')
        momoSpinnerModal.classList.add('active')
        // Add no scroll class to body?
        momoSpinnerModalActive = true
    }
}

export function deactivateSpinnerModal() {
    if (spinnerModal !== null) {
        spinnerModal.classList.add('hidden')
        spinnerModal.classList.remove('active')
        spinnerModalActive = false
    }
}

export function deactivateReadySpinnerModal() {
    if (readySpinnerModal !== null) {
        readySpinnerModal.classList.add('hidden')
        readySpinnerModal.classList.remove('active')
        console.log("ready spinner modal closed")
        readySpinnerModalActive = false
    }    
}

export function deactivateMoMoSpinnerModal() {
    if (momoSpinnerModal !== null) {
        momoSpinnerModal.classList.add('hidden')
        momoSpinnerModal.classList.remove('active')
        console.log("momo spinner modal closed")
        momoSpinnerModalActive = false
    }    
}